<template>
  <div id="wrapper" :style="{'grid-template-rows': `${centralHeight}`}">
    <div id="content">
      <router-view
                   @requestLogin="() => $emit('requestLogin')"
                   @showCdss="(patientData) => $emit('showCdss', patientData)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  emits: {
    requestLogin: null,
    showCdss: null,
  },
  data() {
    return {
      centralHeight: 0
    }
  },
  methods: {
    setCentralSize() {
      this.centralHeight = (window.innerHeight - 20) + 'px'
    }
  },
  created() {
    window.addEventListener('resize', this.setCentralSize)
    this.setCentralSize()
  },
  unmounted() {
    window.removeEventListener('resize', this.setCentralSize);
  }
}
</script>

<style scoped>
#wrapper {
  display: grid;
  grid-template-columns: 100%;
  grid-template-areas: "content";
}

#content {
  grid-area: content;
}

body {
  background-color: black;
}
</style>